/*
 * @Description:
 * @Author: kai.zhou
 * @Date: 2020-04-01 16:27:02
 * @LastEditors: kai.zhou
 * @LastEditTime: 2020-12-07 18:03:33
 */
export default {
  lang: "印地语",
  common: {
    name1: "कार्ड बनाओ!",
    name2: "रैंकिंग लिस्ट!  ",
    name3: "शेयर करें व लाइक्स प्राप्त करें! ",
    name4: "आपको XX लाइक्स मिल चुके हैं ",
    name5: "आप सबसे टॉप X हैं! ऐसे ही लगे रहो!",
    name6: "और लाइक्स प्राप्त करें! ",
    name7: "अपनी जानकारी यहाँ प्रस्तुत करें! ",
    name8: "नाम ",
    name9: "फ़ोन न. ",
    name10: "देश ",
    name11: "सेव करें ",
    name12: "",
    name13:"पहले अपनी शुभकामनाये लिखे ",
    name14:"230 करेक्टर्स तक सिमित ",
    name15:"गिफ्ट्स जीतने के लिए आपकी जानकारी सबमिट करना ना भूले!",
    name16:"1 अपने मित्रों को अभिवादन लिखें, और लाइक्स प्राप्त करने के लिए  शेयर करें ",
    name17:"2 अगर आपको सब ज्यादा लिखे मिलते हैं, तो आपको मिलेगा iPhone 12 मिनी ",
    name18:"3 . अगर आप टॉप 100 में रहते हैं तो भी आपको एक गिफ्ट मिलेगा ",
    name19:"मेर्री क्रिसमस! अभिवादन करें, और जीते iPhone 12 मिनी ",
    name20:"एक अपनी पसंद का कार्ड चुनें ",
    name21:"शीर्षक ",
    name22:"जल्द",
  },
  rules: {
    name1: "आईफ़ोन 12 मिनी ",
    name2: "रिचार्ज ",
    name3: "1GB ",
    name4: "100MB ",
    name5: "उपहार/गिफ्ट्स ",
    name6: "भाग कैसे लें!",
    name7: "1 एक अपनी पसंद का कार्ड चुनें और उस पर अपनी शुभकामनाये लिखे ",
    name8: "2 कार्ड को अपने मित्रों में शेयर करें लाइक्स प्राप्त करने के लिए ",
    name9: "3 जो सबसे ज्यादा लाइक्स लेगा वो जीतेगा आईफ़ोन 12 मिनी ",
    name10: "4 अगर आप टॉप 100 में हैं तो भी आपको एक गिफ्ट मिलेगा ",
    name11: "रैंकिंग लिस्ट ",
    name12: "गिफ्ट लिस्ट ",
    name13:"टॉप 1 ",
    name14:"आईफ़ोन 12 मिनी (64G)",
    name15:"टॉप 2 - टॉप 10 ",
    name16:"",
    name17:"टॉप 11 - टॉप 50 ",
    name18:"1GB ",
    name19:"टॉप 51 - टॉप 100",
    name20:"100MB",
    name21:"कृपया ध्यान दे! ",
    name22:"1 जिनका कार्ल केयर एप पे अकाउंट है वही भाग ले सकते हैं! अगर आपने अकाउंट नहीं बनाय है, तो पहले रजिस्टर करें! ",
    name23:"2 अगर आप गिफ्ट जीतते हैं तो कृपया अपनी जानकारी एक्टिविटी-समय के अनुसार सबमिट करें, नहीं तो गिफ्ट कैंसिल हो जाएगा ",
    name24:"3 किसी शिकायत या मुद्दे के सन्दर्भ में कृपया संपर्क करें: Carlcarelucky@gmail.com ",
    name25:"4 कार्लकेयर अंतिम व्याख्या व फैसले का हक़ रखता है  ",
    name26:"मेर्री क्रिसमस सुभकामनायें दे और आईफ़ोन जीते ",
    name27:"मेर्री क्रिसमस",
    name28:"एक्टिविटी नियम ",
    name29:"ओके ",
    name30:"अपग्रेड ",
    name31:"एक्टिविटी को एन्जॉय करने के लिए अपग्रेड करें ",
    name32:"लॉग-इन ",
    name33:"कृपया पहले लॉग-इन करें ",
    name34:"गेम ओवर ",
    name35:"आपको मिल चुके हैं ",
    name36:"लाइक्स ",
    name37:"मेरी शुभकामनाये ",
    name38:"प्राप्त करे ",
    name39:"रैंक/श्रेणी",
    name40:"आईडी ",
    name41:"नियम ",
    name42:"अभी आप सबसे टॉप",
    name43:"हैं!  ऐसे ही बढ़ते रहें!",
    name44:"कार्ड ",
    name45:"कृपया अपनी सभी डिटेल यहाँ भरें! ",
    name46:'आपकी डिटेल सफलतापूर्वक जमा हो चुकी हैं',
    name47:"मेर्री क्रिसमस - लाइक्स प्राप्त करें, और जीते आईफ़ोन 12",
  },
};